import { useState } from 'react'
import "./PageTrackingSystem.scss"
import HeaderLine from "../../../components/headerLine/HeaderLine"
import TrackingHamMenu from "../trackingHamMenu/TrackingHamMenu"
import Infobox from "../../../components/infobox/Infobox";
import TrackingSystem from "./trackingSystem/TrackingSystem"

export default function PageTrackingSystem(props) {
    const [hamShowed, showHam] = useState(false)

    function onHamClicked() {
        showHam(!hamShowed);
    }

    return (
        <div className="page-tracking-system fullpage">
            <HeaderLine
                selectedPage={"tracking-system"}
                onHamClicked={onHamClicked}
            />

            <aside>
                <TrackingHamMenu
                    show={hamShowed}
                />
            </aside>
            <main>
                <Infobox
                    info={<TrackingSystem />}
                />
            </main>
        </div>
    )
}
